import { initReactI18next } from 'react-i18next';

import { I18N_OPTIONS } from 'helpers/i18Options';

import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import XHR from 'i18next-http-backend';

// for browser use xhr backend to load translations and browser lng detector
i18n.use(initReactI18next).use(XHR).use(LanguageDetector);

// initialize if not already initialized
if (!i18n.isInitialized) {
    i18n.init(I18N_OPTIONS);
}

export default i18n;
